<template>
  <footer class="app-footer">
    <div class="footer-container">
      <div class="footer-copyright">
        © {{ new Date().getFullYear() }} {{ communityName }}. All rights reserved.
      </div>
      <div class="footer-links">
        <RouterLink to="/privacy" class="footer-link">Privacy Policy</RouterLink>
        <span class="separator">•</span>
        <RouterLink to="/terms" class="footer-link">Terms & Conditions</RouterLink>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router';
import { config } from '@/config';

const communityName = config.app.communityName;
</script>

<style scoped>
.app-footer {
  padding: var(--spacing-xl) 0;
  border-top: 1px solid var(--color-border);
  margin-top: auto;
  width: 100%;
}

.footer-container {
  max-width: var(--content-max-width);
  margin: 0 auto;
  padding: 0 var(--spacing-md);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-sm);
}

.footer-copyright {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}

.footer-links {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.footer-link {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.footer-link:hover {
  color: var(--color-primary);
}

.separator {
  color: var(--color-text-muted);
  font-size: var(--font-size-xs);
}

@media (min-width: 768px) {
  .footer-container {
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
